/* eslint-disable consistent-return */
import React from 'react';
import map from 'lodash/map';
import flatten from 'lodash/flatten';
import uniqBy from 'lodash/uniqBy';
import uniq from 'lodash/uniq';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import { listWM, custom } from 'utils/Api';

import { addNotification } from 'reapop';
import { FormattedMessage } from 'react-intl';

import * as types from 'constants/ActionTypes';
import { get } from 'lodash';

export const requestCourses = () => ({
  type: types.REQUEST_COURSES,
});

export const requestCoursesFailure = coursesError => ({
  type: types.REQUEST_COURSES_FAILURE,
  coursesError,
});

export const requestCoursesSuccess = (attendingCourses, openCourses, allCourses) => ({
  type: types.REQUEST_COURSES_SUCCESS,
  attendingCourses,
  openCourses,
  allCourses,
});

export function fetchCourses() {
  return (dispatch, getState) => {
    dispatch(requestCourses());

    const { loginReducer: { user: { token, EmployeeMasterID } } } = getState();
    const n = new Date().toISOString();
    const fetchOpen = {
      entity: 'Course',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $filter: `Entity/CourseStatus eq '0' and CourseBegda gt datetime'${n}' and not Entity/CourseAttendees/any(a: a/EmployeeMasterID eq ${EmployeeMasterID})`,
        $orderby: 'CourseBegda asc',
      },
    };
    const fetchAttending = {
      entity: 'Course',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $filter: `Entity/CourseStatus eq '0' and Entity/CourseAttendees/any(a: a/EmployeeMasterID eq ${EmployeeMasterID}) and CourseEndda gt datetime'${n}'`,
        $orderby: 'CourseBegda asc',
      },
    };

    const fetchDetailOrg = {
      entity: 'EmployeeDetailOrg',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $expand: 'Entity',
        $select: 'Entity/EmployeeDetailOrgID, Entity/OrgCompanyID, Entity/OrgCompanyUnitID, Entity/OrgCompanyUnitPositionID',
        $filter: `Entity/EmployeeDetailID ge ${EmployeeMasterID}1 and Entity/EmployeeDetailID le ${EmployeeMasterID}9 and (Entity/EmployeeStatus eq '0' or (Entity/EmployeeStatus ge '4'  and Entity/EmployeeStatus le '7')) and Entity/Begda le datetime'${n}' and Entity/Endda ge datetime'${n}'`,
      },
    };

    // TODO
    // 1. Befor fetching the courses that are open we need to fetch the users EmployeeDetailOrg
    // 2. From the EmployeeDetailOrg retrieve the users OrgCompanyID, OrgCompanyUnitID, OrgCompanyUnitPositionID
    // 3. Fetch all CourseTargetsObjects that have the users info to get the CourseTargetId
    // 4. Then we can ensure that we only fetch courses that have no CourseTargetCourses or CourseTargetCourses with specific IDs

    listWM(fetchDetailOrg)
      .then(
        (employeeDetailOrgs) => {
          // go though the detail orgs and pick out the objectIDs for the request
          const objectMapping = uniqBy(flatten(map(employeeDetailOrgs.data, dOrg => ([
            { ObjectType: 'OrgCompany', ObjectID: dOrg.OrgCompanyID },
            { ObjectType: 'OrgCompanyUnit', ObjectID: dOrg.OrgCompanyUnitID },
            { ObjectType: 'OrgCompanyUnitPosition', ObjectID: dOrg.OrgCompanyUnitPositionID },
          ]))), x => `${x.ObjectType}-${x.ObjectID}`);
          // User only ever have one EmployeeMasterID
          objectMapping.push({ ObjectType: 'EmployeeMaster', ObjectID: EmployeeMasterID });
          const fetchTargetIDs = {
            url: `/kjarni/api/v2/CourseTargetObjects?$filter=${map(objectMapping, o => `(ObjectType eq '${o.ObjectType}' and ObjectID eq ${o.ObjectID})`).join` or `}`,
            method: 'Get',
          };
          custom(fetchTargetIDs)
            .then(
              (courseTargetObjects) => {
                const courseTargetIDs = uniq(map(courseTargetObjects.data.value, cto => cto.CourseTargetID));
                if (courseTargetIDs.length) {
                  fetchOpen.params.$filter += ` and ((not Entity/CourseTargetCourses/any()) or (Entity/CourseTargetCourses/any(a: ${map(courseTargetIDs, ctID => `a/CourseTargetID eq ${ctID}`).join` or `})))`;
                } else {
                  fetchOpen.params.$filter += ' and (not Entity/CourseTargetCourses/any())';
                }
                listWM(fetchOpen)
                  .then(
                    (openCourses) => {
                      listWM(fetchAttending)
                        .then(
                          (attendingCourses) => {
                            dispatch(requestCoursesSuccess(
                              attendingCourses.data.map(c => ({
                                ...c,
                                MainCourseAttendeeID: c.CourseAttendees.find(a => a.EmployeeMasterID === EmployeeMasterID).CourseAttendeeID,
                                CourseTimes: c.CourseTimes.map(t => ({ ...t, ...t.Entity })),
                              })),
                              openCourses.data.map(c => ({
                                ...c,
                                CourseTimes: c.CourseTimes.map(t => ({ ...t, ...t.Entity })),
                              })),
                              orderBy([...attendingCourses.data.map(c => ({ ...c, Attending: true })), ...openCourses.data], [c => new Date(c.CourseBegda).getTime()], ['asc']),
                            ));
                          },
                          error => dispatch(requestCoursesFailure(error)),
                        );
                    },
                    error => dispatch(requestCoursesFailure(error)),
                  );
              },
              error => dispatch(requestCoursesFailure(error)),
            );
        },
        error => dispatch(requestCoursesFailure(error)),
      );
  };
}

export function fetchCoursesIfNeeded() {
  return (dispatch, getState) => {
    if (isEmpty(getState().coursesReducer.openCourses)) {
      dispatch(fetchCourses());
    }
  };
}

/* ------------ COURSE ATTENDANCE ------------ */

export function requestCourseAttendance() {
  return {
    type: types.REQUEST_COURSE_ATTENDANCE,
  };
}

export function requestCourseAttendanceSuccess() {
  return {
    type: types.REQUEST_COURSE_ATTENDANCE_SUCCESS,
  };
}

export function requestCourseAttendanceFailure(error) {
  return {
    type: types.REQUEST_COURSE_ATTENDANCE_FAILURE,
    error,
  };
}

export const attendCourse = (CourseID, QuestionnaireRootAnswerID) =>
  async (dispatch, getState) => {
    try {
      const {
        loginReducer: {
          user: { EmployeeMasterID },
        },
        coursesReducer: { allCourses },
      } = getState();

      const data = {
        CourseID,
        EmployeeMasterID,
        QuestionnaireRootAnswerID,
      };

      const Course = find(allCourses, ['CourseID', CourseID]);
      if (Course.CourseAttendeeRegistered >= Course.CourseMaxAttendance) {
        return dispatch(addNotification({
          title: <FormattedMessage id="notification.register.title" />,
          message: <FormattedMessage id="notification.register.full" />,
          status: 'error',
          dismissible: true,
          dismissibleAfter: 0,
        }));
      }
      const registerRequest = {
        url: '/kjarni/api/v2/CourseAttendees/Register',
        method: 'Post',
        data,
      };
      dispatch(requestCourseAttendance());
      await custom(registerRequest);
      dispatch(requestCourseAttendanceSuccess());
      dispatch(fetchCourses());
    } catch (err) {
      dispatch(requestCourseAttendanceFailure(get(err, 'message')));
    }
  };

/* ------------ COURSE LEAVE ------------ */

export function requestCourseLeave() {
  return {
    type: types.REQUEST_COURSE_LEAVE,
  };
}

export function requestCourseLeaveSuccess() {
  return {
    type: types.REQUEST_COURSE_LEAVE_SUCCESS,
  };
}

export function requestCourseLeaveFailure(error) {
  return {
    type: types.REQUEST_COURSE_LEAVE_FAILURE,
    error,
  };
}

export const leaveCourse = CourseAttendeeID => async (dispatch) => {
  try {
    dispatch(requestCourseLeave());
    const unregisterRequest = {
      url: '/kjarni/api/v2/CourseAttendees/UnRegister',
      method: 'Post',
      data: { CourseAttendeeID },
    };
    await custom(unregisterRequest);
    dispatch(requestCourseLeaveSuccess());
    dispatch(fetchCourses());
  } catch (err) {
    const msg = get(err, 'error.message', 'Villa');
    dispatch(addNotification({
      title: 'Villa við afskráningu',
      message: msg,
      status: 'error',
      dismissible: true,
      dismissAfter: 12000,
    }));
    // dispatch(requestCourseLeaveFailure({ Message: msg }));
  }
};

/* --------------------- EMPLOYEE MASTER COURSE ---------------------- */

export function requestEmployeeMasterCourses() {
  return {
    type: types.REQUEST_EMPLOYEE_MASTER_COURSES,
    employeeMasterCourses: [],
    employeeMasterCoursesLoaded: false,
    sentAt: Date.now(),
    error: null,
  };
}

export function requestEmployeeMasterCoursesFailure(error) {
  return {
    type: types.REQUEST_EMPLOYEE_MASTER_COURSES_FAILURE,
    employeeMasterCourses: [],
    employeeMasterCoursesLoaded: true,
    receivedAt: Date.now(),
    error,
  };
}

export function requestEmployeeMasterCoursesSuccess(employeeMasterCourses) {
  return {
    type: types.REQUEST_EMPLOYEE_MASTER_COURSES_SUCCESS,
    employeeMasterCoursesLoaded: true,
    receivedAt: Date.now(),
    employeeMasterCourses,
    error: null,
  };
}

export function fetchEmployeeMasterCourses() {
  return (dispatch, getState) => {
    dispatch(requestEmployeeMasterCourses());
    const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();
    const fetchConfig = {
      entity: 'EmployeeMasterCourse',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $filter: `Entity/EmployeeMasterID eq ${EmployeeMasterID}`,
      },
    };

    listWM(fetchConfig)
      .then(({ data }) => dispatch(requestEmployeeMasterCoursesSuccess(data)))
      .catch(error => dispatch(requestEmployeeMasterCoursesFailure(error)));
  };
}

export function fetchEmployeeMasterCoursesIfNeeded() {
  return (dispatch, getState) =>
    isEmpty(getState().coursesReducer.employeeMasterCourses) &&
    dispatch(fetchEmployeeMasterCourses());
}



// WEBPACK FOOTER //
// ./src/actions/courses.js